import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	async getCommCodes(codeType, plantCd) {
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${codeType}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	getPowTourRgstManagements: ({ searchParams }) => {
		let queryStr = '';
		queryStr = objectToQuerystring({
			powLnCd: searchParams.powLnCd,
			insnDd: searchParams.insnDd,
			insnRsltCd: searchParams.insnRsltCd,
			insnCyclCd: searchParams.insnCyclCd,
			ipnNos: searchParams.ipnNos
		});
		return client
			.get(`${BASE_URL}/pqy/ptin/powTourRgst/v1/powTourRgsts` + queryStr)
			.then(response => response?.data)
			.catch(error => {
				throw error?.response?.data;
			});
	},
	postPowTourRgstManagement: ({ formData }) => {
		//console.log('debug', formData);
		let url = `${BASE_URL}/pqy/ptin/powTourRgst/v1/status/1`;
		return client
			.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	postPowTourRgstDelete: ({ formData }) => {
		//console.log('debug', formData);
		let url = `${BASE_URL}/pqy/ptin/powTourRgst/v1/status/3`;
		return client
			.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	fileDownload: ({ params }) => {
		// console.log('params', params);
		// 이미지 미리보기와 실제파일 다운로드에서 같이 사용하기 때문에 주의할것
		return new Promise((resolve, reject) => {
			client
				.post(`${BASE_URL}/comm/common/qmsFileInfo/v1/downloadFiles`, params, { responseType: 'blob' })
				.then(response => {
					resolve(response);
				})
				.catch(error => reject(new Error(error.message || error.response)));
		});
	}
};
